import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendQuery, BackendQueryFacebookPermissionsArgs } from 'src/types/backend';

const QUERY = gql`
  query FacebookPermissions($customerId: ID!) {
    facebookPermissions(customerId: $customerId)
  }
`;

type Variables = BackendQueryFacebookPermissionsArgs;
type Result = NonNullable<BackendQuery['facebookPermissions']>;

export const queryFacebookPermissions = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });
  return getSingleProp<Result>(result.data);
};
